function setMainChartFilter(){
	if((mainGraphFilter == 'admissions' || mainGraphFilter == 'discharges') && (graphType != 'Pie' && graphType != 'Doughnut')){
		if(mainGraphFilter == 'admissions'){
			setMainDimensionTo('admit_dt');
			paytypeFunction = function(PayArray){
				var sorted = Object.keys(PayArray).sort(function(a,b){return b - a});
				return PayArray[sorted[0]];
			}
		}else{
			paytypeFunction = function(PayArray){
				var sorted = Object.keys(PayArray).sort(function(a,b){return b - a});
				return PayArray[sorted[0]];
			}
			setMainDimensionTo('discharge_dt');
		}
		setMainGroupPaytypeStackedWith(paytypeFunction);
	}else if(mainGraphFilter == 'census' && (graphType != 'Pie' && graphType != 'Doughnut')){
		setMainDimensionTo('admit_dt');
		var customVars = [
		{
			varName: 'adc',
			defaultState: 0,
			addition: function(p,v){
				return (p.count / bedCount) * 100;
			},
			subtraction: function(p,v){
				return (p.count / bedCount) * 100;
			}
		},
		{
			varName: 'adcAverage',
			defaultState: 0,
			addition: function(p,v){
				var monthYear = new Date(v.admit_dt);
				return p.adc / daysInMonth((monthYear.getMonth() + 1), monthYear.getFullYear());
			},
			subtraction: function(p,v){
				var monthYear = new Date(v.admit_dt);
				return p.adc / daysInMonth((monthYear.getMonth() + 1), monthYear.getFullYear());
			}
		}
		];
		paytypeFunction = function(PayArray){
			var sorted = Object.keys(PayArray).sort(function(a,b){return a - b});
			return PayArray[sorted[0]];
		}
		if(isWithinMonth){
			setMainGroupPaytypeStackedWith(paytypeFunction, customVars, 'adc');
		}else{
			setMainGroupPaytypeStackedWith(paytypeFunction, customVars, 'adcAverage');
		}
	}else if((mainGraphFilter == 'lengthofstay' || mainGraphFilter == 'lengthofstaytotal') && (graphType != 'Pie' && graphType != 'Doughnut')){
		setMainDimensionTo('admit_dt', true);

		var customVars = [
		{
			varName: 'los',
			defaultState: 0,
			addition: function(p,v){
				return p.los += v.LOS;
			},
			subtraction: function(p,v){
				return p.los -= v.LOS;
			}
		},
		{
			varName: 'avgLOS',
			defaultState: 0,
			addition: function(p,v){
				return p.count ? (p.los / p.count) : 0
			},
			subtraction: function(p,v){
				return p.count ? (p.los / p.count) : 0
			}
		}
		];
		paytypeFunction = function(PayArray){
			var sorted = Object.keys(PayArray).sort(function(a,b){return b - a});
			return PayArray[sorted[0]];
		}
		setMainGroupPaytypeStackedWith(paytypeFunction, customVars, losType);
	}else if(mainGraphFilter == 'deficiencies' && (graphType != 'Pie' && graphType != 'Doughnut')){
		mainDimension = deficienciesNDX.dimension(function(d){
			return d.letter;
		});

		var indicatorsMap = {};
		indicatorData.forEach(function(d){
			if(!(d.letter in indicatorsMap)){
				indicatorsMap[d.letter] = [];
			}
			indicatorsMap[d.letter].push(d);
		});
		var firstIndicators = [];
		var stackIndicators = [];
		for(var indicatorLetter in indicatorsMap){
			firstIndicators.push(indicatorsMap[indicatorLetter][0].td_uid);
			indicatorsMap[indicatorLetter].splice(0,1);
		}

		for(var letter in indicatorsMap){
			stackIndicators.push(indicatorsMap[letter].map(function(indicator){
				return indicator.td_uid;
			}));
		}

		mainGroup = mainDimension.group().reduce(
			function(p,v){
				if(firstIndicators.indexOf(v.td_uid) !== -1){
					if(v.samples) v.samples.forEach(function(sample, i){
						if(typeof sample == 'string' || sample instanceof String){
							var name = {'name':sample, 'id':0, 'paytype':0, 'origin':0};
						}else{ //its a resident that we matched
							var name = {'name': sample.name, 'id': sample.id, 'paytype': sample.financial, 'origin': sample.origin};
						}
						if(v.no && v.no.indexOf((i + 1).toString()) !== -1){
							p.answers[(i + 1)] = 2;
						}else if(v.yes && v.yes.indexOf((i + 1).toString()) !== -1){
							p.answers[(i + 1)] = 1;
						}
						if(p.names['all'].indexOf(name) === -1){
		        			p.names['all'].push(name);
		            	}
					});
					var tooltip = {tag: v.tag, indicator: v.indicator_name};
	        		p.tooltip.push(tooltip);
					p.total++;
					p.indicator = v.indicator_name;
					p.td_uid = v.td_uid;
					p.ftag = v.deptartment_abbreviation+'-'+v.ind_dep_count;
					p.regulation = v.regulation;
					p.category = v.department;
					p.month = v.month;
					p.year = v.year;
				}
				return p;
			},
			function(p,v){
				if(firstIndicators.indexOf(v.td_uid) !== -1){
					var allNames = p.names['all'];
					v.samples.forEach(function(sample){
						for(var i = 0; i < allNames.length; i++){
							if(allNames[i].name == name.name){
								allNames.splice(i,1);
								i--;
							}
						}
					});
					p.names['all'] = allNames;
					var allTooltip = p.tooltip;
					for(var i = 0; i < allTooltip.length; i++){
						if(allTooltip[i].name == name.name){
							allTooltip.splice(i,1);
							i--;
						}
					}
					p.tooltip = allTooltip;
					p.total--;
				}
				return p;
			},
			function(){
				return{
					total: 0,
					names: {'all': []},
					tooltip: [],
					answers: {},
					indicator: '',
					td_uid: 0,
					ftag: '',
					regulation: '',
					category: '',
					month: 0,
					year: '',
				}
			}
		);

		stackIndicators = flattenArray(stackIndicators);

		mainChart
			.dimension(mainDimension)
			.group(mainGroup, firstIndicators);
			for(var i = 0; i < stackIndicators.length; i++){
			    (function(j) {
			    	var group = mainDimension.group().reduce(
			         		function(p,v){
			         			if(v.td_uid == stackIndicators[j]){
			         				//console.log(v.samples);
			         				if(v.samples == undefined){
			         					return p;
			         				}
     								if(v.samples) v.samples.forEach(function(sample, i){
     									if(typeof sample == 'string' || sample instanceof String){
     										var name = {'name':sample, 'id':0, 'paytype':0, 'origin':0};
     									}else{ //its a resident that we matched
     										var name = {'name': sample.name, 'id': sample.id, 'paytype': sample.financial, 'origin': sample.origin};
     									}
     									if(v.no && v.no.indexOf((i + 1).toString()) !== -1){
     										p.answers[(i + 1)] = 2;
     									}else if(v.yes && v.yes.indexOf((i + 1).toString()) !== -1){
     										p.answers[(i + 1)] = 1;
     									}
     									if(p.names['all'].indexOf(name) === -1){
     					        			p.names['all'].push(name);
     					            	}
     								});
     								var tooltip = {tag: v.tag, indicator: v.indicator_name};
     				        		p.tooltip.push(tooltip);
     								p.total++;
     								p.indicator = v.indicator_name;
     								p.td_uid = v.td_uid;
     								p.ftag = v.deptartment_abbreviation+'-'+v.ind_dep_count;
     								p.regulation = v.regulation;
     								p.category = v.department;
     								p.month = v.month;
     								p.year = v.year;
			         			}
			         			return p;
			         		},
			         		function(p,v){
			         			if(v.td_uid == stackIndicators[j]){
			         				var allNames = p.names['all'];
 									v.samples.forEach(function(sample){
 										for(var i = 0; i < allNames.length; i++){
 											if(allNames[i].name == name.name){
 												allNames.splice(i,1);
 												i--;
 											}
 										}
 									});
 									p.names['all'] = allNames;
 									var allTooltip = p.tooltip;
 									for(var i = 0; i < allTooltip.length; i++){
 										if(allTooltip[i].name == name.name){
 											allTooltip.splice(i,1);
 											i--;
 										}
 									}
 									p.tooltip = allTooltip;
 									p.total--;
			         			}
			         			return p;
			         		},
			         		function(){
			         			var defaultVars = {
			         				total: 0,
			         				names: {'all': []},
			         				tooltip: [],
			         				answers: {},
			         				indicator: '',
			         				td_uid: 0,
			         				ftag: '',
			         				regulation: '',
			         				category: '',
			         				month: 0,
			         				year: ''
			         			}
			         			return defaultVars;
			         		}
			         	);
			        mainChart
			         	.stack(group, function(d){
			         		return d.value;
			         	}, stackIndicators[j]);
			    })(i);
			}

		mainValueAccessor = {
								valueAccessor: function(p){
									return p.value.total;
								}
							};
	}else if(mainGraphFilter == 'surveys'){
		if(graphType != 'Pie' && graphType != 'Doughnut'){
			mainDimension = surveyNDX.dimension(function(d){
				return d3.time.month(d.assignedMonthYear);
			});

			mainGroup = mainDimension.group().reduce(
				function(p,v){
					for(var answer in v.answers){
						if(v.answers[answer] == 1){
							p.type = 1;
	     					p.total++;
	     					p.answer = 1 * p.total;
	     					p.month = d3.time.month(v.assignedMonthYear);
	     					var tooltip = {tag: v.tag, indicator: v.indicator_name, id: v.td_uid};
	     					if(p.tooltip.indexOf(tooltip) === -1){
	     						p.tooltip.push(tooltip);
	     					}
	     					sample = v.samples[answer - 1];
							if(typeof sample == 'string' || sample instanceof String){
								var name = {'name':sample, 'id':0, 'paytype':0, 'origin':0, 'answer': p.type, 'date': d3.time.month(v.assignedMonthYear)};
							}else{ //its a resident that we matched
								var name = {'name': sample.name, 'id': sample.id, 'paytype': sample.financial, 'origin': sample.origin, 'answer': p.type, 'date': d3.time.month(v.assignedMonthYear)};
							}
							if(p.names['all'].indexOf(name) === -1){
			        			p.names['all'].push(name);
			            	}
						}
					}
					return p;
				},
				function(p,v){
					var allTooltip = p.tooltip;
					var allNames = p.names['all'];
					for(var answer in v.answers){
						if(v.answers[answer] == 1){
	     					p.total--;
	     					p.answer = 1 * p.total;
	     					for(var t = 0; t < allTooltip.length; t++){
	     						if(allTooltip[t].id == v.td_uid){
	     							allTooltip.splice(t,1);
	     							t--;
	     						}
	     					}
	     					var sample = v.samples[answer - 1];
	 						for(var i = 0; i < allNames.length; i++){
	 							if(allNames[i].name == sample.name){
	 								allNames.splice(i,1);
	 								i--;
	 							}
	 						}
						}
					}
					p.tooltip = allTooltip;
					p.names['all'] = allNames;
					return p;
				},
				function(){
					return {
						total: 0,
						type: 0,
						answer: 0,
						tooltip: [],
						names: {'all': []},
						month: ''
					};
				});
				mainChart
					.dimension(mainDimension)
					.group(mainGroup);

				for(var i = 2; i <= 5; i++){
				    (function(j) {
				    	var group = mainDimension.group().reduce(
				         		function(p,v){
				         			for(var answer in v.answers){
	     								if(v.answers[answer] == j){
	     									p.type = j;
	     			     					p.total++;
	     			     					p.answer = j * p.total;
	     			     					p.month = d3.time.month(v.assignedMonthYear);
	     			     					var tooltip = {tag: v.tag, indicator: v.indicator_name, id: v.td_uid};
	     			     					if(p.tooltip.indexOf(tooltip) === -1){
	     			     						p.tooltip.push(tooltip);
	     			     					}
					     					sample = v.samples[answer - 1];
					     					if(sample == undefined){
					     						continue;
					     					}
											if(typeof sample == 'string' || sample instanceof String){
												var name = {'name':sample, 'id':0, 'paytype':0, 'origin':0, 'answer': p.type, 'date': d3.time.month(v.assignedMonthYear)};
											}else{ //its a resident that we matched
												var name = {'name': sample.name, 'id': sample.id, 'paytype': sample.financial, 'origin': sample.origin, 'answer': p.type, 'date': d3.time.month(v.assignedMonthYear)};
											}
											if(p.names['all'].indexOf(name) === -1){
							        			p.names['all'].push(name);
							            	}
	     								}
	     							}
				         			return p;
				         		},
				         		function(p,v){
				         			var allTooltip = p.tooltip;
		 							var allNames = p.names['all'];
				         			for(var answer in v.answers){
		 								if(v.answers[answer] == j){
		 			     					p.total--;
		 			     					p.answer = j * p.total;
		 			     					for(var t = 0; t < allTooltip.length; t++){
		 			     						if(allTooltip[t].id == v.td_uid){
		 			     							allTooltip.splice(t,1);
		 			     							t--;
		 			     						}
		 			     					}
					    					var sample = v.samples[answer - 1];
											for(var i = 0; i < allNames.length; i++){
												if(allNames[i].name == sample.name){
													allNames.splice(i,1);
													i--;
												}
											}
		 								}
		 							}
		 							p.tooltip = allTooltip;
		 							p.names['all'] = allNames;
				         			return p;
				         		},
				         		function(){
				         			var defaultVars = {
				         				total: 0,
				         				type: 0,
				         				answer: 0,
				         				tooltip: [],
				         				names: {'all': []},
				         				month: ''
				         			}
				         			return defaultVars;
				         		}
				         	);
				        mainChart
				         	.stack(group, function(d){
				         		return d.value.total;
				         	});
				    })(i);
				}

				mainValueAccessor = {
										valueAccessor: function(p){
											return p.value.total;
										}
									};
		}else{
			mainDimension = surveyNDX.dimension(function(d){
			    return d.answers;
			});

			mainGroup = mainDimension.groupAll().reduce(
			    function(p, v) {
			        for(var answer in v.answers){
			            p[v.answers[answer]] = (p[v.answers[answer]] || {names: {'all': []}, 'tooltip': []});
			            p[v.answers[answer]].total = (p[v.answers[answer]].total || 0) + 1;
			            p[v.answers[answer]].type = v.answers[answer];
			            p[v.answers[answer]].tooltip.push({tag: v.tag, indicator: v.indicator_name, id: v.td_uid});
			            v.samples.forEach(function(sample){
        					if(typeof sample == 'string' || sample instanceof String){
        						var name = {'name':sample, 'id':0, 'paytype':0, 'origin':0, 'answer': v.answers[answer], 'date': d3.time.month(v.assignedMonthYear)};
        					}else{ //its a resident that we matched
        						var name = {'name': sample.name, 'id': sample.id, 'paytype': sample.financial, 'origin': sample.origin, 'answer': v.answers[answer], 'date': d3.time.month(v.assignedMonthYear)};
        					}
        					if(p[v.answers[answer]].names['all'].indexOf(name) === -1){
        	        			p[v.answers[answer]].names['all'].push(name);
        	            	}
			            })
			        }
			        return p;
			    },
			    function(p, v) {
			        for(var answer in v.answers){
			        	var allNames = p[v.answers[answer]].names['all'];
			        	var allTooltip = p[v.answers[answer]].tooltip;
			            p[v.answers[answer]].total = (p[v.answers[answer]].total || 0) - 1;
			            for(var t = 0; t < allTooltip.length; t++){
			            	if(allTooltip[t].id == v.td_uid){
			            		allTooltip.splice(t,1);
			            		t--;
			            	}
			            }
    					v.samples.forEach(function(sample){
							for(var i = 0; i < allNames.length; i++){
								if(allNames[i].name == sample.name){
									allNames.splice(i,1);
									i--;
								}
							}
						});
						p[v.answers[answer]].names['all'] = allNames;
						p[v.answers[answer]].tooltip = allTooltip;
			        }
			        return p;
			    },
			    function(p, v) {
			        return {};
			    }
			);
			mainGroup = mainGroup.value();
			mainGroup.all = function() {
			    var newObject = [];
			    for (var key in this){
			        if(this.hasOwnProperty(key) && key != 'all') {
			            newObject.push({
			                key: key,
			                value: this[key]
			            });
			        }
			    }
			    return newObject;
			}
			mainChart
					.dimension(mainDimension)
					.group(mainGroup);

		}
	}else if(mainGraphFilter == 'qis'){
		if(graphType != 'Pie' && graphType != 'Doughnut'){
			mainDimension = qisNDX.dimension(function(d){
				return d3.time.month(d.assignedMonthYear);
			});

			mainGroup = mainDimension.group().reduce(
				function(p,v){
					for(var answer in v.answers){
						if(v.answers[answer] == 1){
							p.type = 1;
	     					p.total++;
	     					p.answer = 1 * p.total;
	     					p.month = d3.time.month(v.assignedMonthYear);
	     					var tooltip = {tag: v.tag, indicator: v.indicator_name, id: v.td_uid};
	     					if(p.tooltip.indexOf(tooltip) === -1){
	     						p.tooltip.push(tooltip);
	     					}
	     					sample = v.samples[answer - 1];
							if(typeof sample == 'string' || sample instanceof String){
								var name = {'name':sample, 'id':0, 'paytype':0, 'origin':0, 'answer': p.type, 'date': d3.time.month(v.assignedMonthYear)};
							}else{ //its a resident that we matched
								var name = {'name': sample.name, 'id': sample.id, 'paytype': sample.financial, 'origin': sample.origin, 'answer': p.type, 'date': d3.time.month(v.assignedMonthYear)};
							}
							if(p.names['all'].indexOf(name) === -1){
			        			p.names['all'].push(name);
			            	}
						}
					}
					return p;
				},
				function(p,v){
					var allTooltip = p.tooltip;
					var allNames = p.names['all'];
					for(var answer in v.answers){
						if(v.answers[answer] == 1){
	     					p.total--;
	     					p.answer = 1 * p.total;
	     					for(var t = 0; t < allTooltip.length; t++){
	     						if(allTooltip[t].id == v.td_uid){
	     							allTooltip.splice(t,1);
	     							t--;
	     						}
	     					}
	     					var sample = v.samples[answer - 1];
	 						for(var i = 0; i < allNames.length; i++){
	 							if(allNames[i].name == sample.name){
	 								allNames.splice(i,1);
	 								i--;
	 							}
	 						}
						}
					}
					p.tooltip = allTooltip;
					p.names['all'] = allNames;
					return p;
				},
				function(){
					return {
						total: 0,
						type: 0,
						answer: 0,
						tooltip: [],
						names: {'all': []},
						month: ''
					};
				});
				mainChart
					.dimension(mainDimension)
					.group(mainGroup);

				for(var i = 2; i <= 2; i++){
				    (function(j) {
				    	var group = mainDimension.group().reduce(
				         		function(p,v){
				         			for(var answer in v.answers){
	     								if(v.answers[answer] == j){
	     									p.type = j;
	     			     					p.total++;
	     			     					p.answer = j * p.total;
	     			     					p.month = d3.time.month(v.assignedMonthYear);
	     			     					var tooltip = {tag: v.tag, indicator: v.indicator_name, id: v.td_uid};
	     			     					if(p.tooltip.indexOf(tooltip) === -1){
	     			     						p.tooltip.push(tooltip);
	     			     					}
					     					sample = v.samples[answer - 1];
											if(typeof sample == 'string' || sample instanceof String){
												var name = {'name':sample, 'id':0, 'paytype':0, 'origin':0, 'answer': p.type, 'date': d3.time.month(v.assignedMonthYear)};
											}else{ //its a resident that we matched
												var name = {'name': sample.name, 'id': sample.id, 'paytype': sample.financial, 'origin': sample.origin, 'answer': p.type, 'date': d3.time.month(v.assignedMonthYear)};
											}
											if(p.names['all'].indexOf(name) === -1){
							        			p.names['all'].push(name);
							            	}
	     								}
	     							}
				         			return p;
				         		},
				         		function(p,v){
				         			var allTooltip = p.tooltip;
		 							var allNames = p.names['all'];
				         			for(var answer in v.answers){
		 								if(v.answers[answer] == j){
		 			     					p.total--;
		 			     					p.answer = j * p.total;
		 			     					for(var t = 0; t < allTooltip.length; t++){
		 			     						if(allTooltip[t].id == v.td_uid){
		 			     							allTooltip.splice(t,1);
		 			     							t--;
		 			     						}
		 			     					}
					    					var sample = v.samples[answer - 1];
											for(var i = 0; i < allNames.length; i++){
												if(allNames[i].name == sample.name){
													allNames.splice(i,1);
													i--;
												}
											}
		 								}
		 							}
		 							p.tooltip = allTooltip;
		 							p.names['all'] = allNames;
				         			return p;
				         		},
				         		function(){
				         			var defaultVars = {
				         				total: 0,
				         				type: 0,
				         				answer: 0,
				         				tooltip: [],
				         				names: {'all': []},
				         				month: ''
				         			}
				         			return defaultVars;
				         		}
				         	);
				        mainChart
				         	.stack(group, function(d){
				         		return d.value.total;
				         	});
				    })(i);
				}

				mainValueAccessor = {
										valueAccessor: function(p){
											return p.value.total;
										}
									};
		}else{
			mainDimension = qisNDX.dimension(function(d){
			    return d.answers;
			});

			mainGroup = mainDimension.groupAll().reduce(
			    function(p, v) {
			        for(var answer in v.answers){
			            p[v.answers[answer]] = (p[v.answers[answer]] || {names: {'all': []}, 'tooltip': []});
			            p[v.answers[answer]].total = (p[v.answers[answer]].total || 0) + 1;
			            p[v.answers[answer]].type = v.answers[answer];
			            p[v.answers[answer]].tooltip.push({tag: v.tag, indicator: v.indicator_name, id: v.td_uid});
			            v.samples.forEach(function(sample){
        					if(typeof sample == 'string' || sample instanceof String){
        						var name = {'name':sample, 'id':0, 'paytype':0, 'origin':0, 'answer': v.answers[answer], 'date': d3.time.month(v.assignedMonthYear)};
        					}else{ //its a resident that we matched
        						var name = {'name': sample.name, 'id': sample.id, 'paytype': sample.financial, 'origin': sample.origin, 'answer': v.answers[answer], 'date': d3.time.month(v.assignedMonthYear)};
        					}
        					if(p[v.answers[answer]].names['all'].indexOf(name) === -1){
        	        			p[v.answers[answer]].names['all'].push(name);
        	            	}
			            })
			        }
			        return p;
			    },
			    function(p, v) {
			        for(var answer in v.answers){
			        	var allNames = p[v.answers[answer]].names['all'];
			        	var allTooltip = p[v.answers[answer]].tooltip;
			            p[v.answers[answer]].total = (p[v.answers[answer]].total || 0) - 1;
			            for(var t = 0; t < allTooltip.length; t++){
			            	if(allTooltip[t].id == v.td_uid){
			            		allTooltip.splice(t,1);
			            		t--;
			            	}
			            }
    					v.samples.forEach(function(sample){
							for(var i = 0; i < allNames.length; i++){
								if(allNames[i].name == sample.name){
									allNames.splice(i,1);
									i--;
								}
							}
						});
						p[v.answers[answer]].names['all'] = allNames;
						p[v.answers[answer]].tooltip = allTooltip;
			        }
			        return p;
			    },
			    function(p, v) {
			        return {};
			    }
			);
			mainGroup = mainGroup.value();
			mainGroup.all = function() {
			    var newObject = [];
			    for (var key in this){
			        if(this.hasOwnProperty(key) && key != 'all') {
			            newObject.push({
			                key: key,
			                value: this[key]
			            });
			        }
			    }
			    return newObject;
			}
			mainChart
					.dimension(mainDimension)
					.group(mainGroup);

		}
	}else if(mainGraphFilter == 'compare-star' && graphType != 'Pie' && graphType != 'Doughnut'){
		if(zip !== false){
			compareData.forEach(function(d, i){
				if(('isLocal' in d) && d.isLocal){
					compareData.splice(i,1);
					if(i != 0){
						i--;
					}
				}
			});
		}
		if(nearbyRange == 'federal'){
			compareData.forEach(function(d){
				if(('isLocal' in d) && d.isLocal){
					d.state = d.facility_name;
				}else if('realState' in d){
					d.state = d.realState;
				}
			});
		}
		if(nearbyRange == 'state'){
			compareData.forEach(function(d){
				if(('isLocal' in d) && d.isLocal){
					d.realCounty = d.county;
					d.county = d.facility_name;
				}else if('realState' in d){
					d.county = d.realCounty;
				}
			});
		}
		var filter = 'overall_rating';
		compareStarRatings.forEach(function(d){
		    if(d.selected){
		        filter = d.key;
		    }
		});
		if(nearbyRange == 'federal' || nearbyRange == 'state'){
			mainDimension = compareOtherNDX.dimension(function(d){
			    return Math.round(d[filter]);
			});
		}else{
			mainDimension = compareNDX.dimension(function(d){
			    return Math.round(d[filter]);
			});
		}


		var facilitiesMap = {};
		compareData.forEach(function(d){
			if(!(Math.round(d[filter]) in facilitiesMap)){
				facilitiesMap[Math.round(d[filter])] = [];
			}
			facilitiesMap[Math.round(d[filter])].push(d);
		});
		var firstFacilities = [];
		var stackFacilities = [];

		for(var rating in facilitiesMap){
			if(nearbyRange == 'federal'){
				firstFacilities.push(facilitiesMap[rating][0].state);
			}else if(nearbyRange == 'state'){
				firstFacilities.push(facilitiesMap[rating][0].county);
			}else{
				firstFacilities.push(facilitiesMap[rating][0].provider_number);
			}
			facilitiesMap[rating].splice(0,1);
		}

		for(var rating in facilitiesMap){
			stackFacilities.push(facilitiesMap[rating].map(function(facility){
				if(nearbyRange == 'federal'){
					return facility.state;
				}else if(nearbyRange == 'state'){
					return facility.county;
				}else{
					return facility.provider_number;
				}
			}));
		}
		if(nearbyRange == 'federal' || nearbyRange == 'state'){
			var index = (nearbyRange == 'federal' ? 'state' : 'county');
			mainGroup = mainDimension.group().reduce(
				function(p,v){
					if(firstFacilities.indexOf(v[index]) !== -1){
						p.total = 1;
						p.other = v[index];
						if(nearbyRange == 'federal'){
							p.tooltip = {name: (states[v.state] == undefined ? thisFacilityData.facility_name : states[v.state]), ratings: {'Health Inspection': parseFloat(v.health_inspection_rating), 'Quality Measures': parseFloat(v.qm_rating), 'Registered Nursing Staffing': parseFloat(v.rn_staffing_rating)}};
						}else if(nearbyRange == 'state'){
							p.tooltip = {name: v.county, ratings: {'Health Inspection': parseFloat(v.health_inspection_rating), 'Quality Measures': parseFloat(v.qm_rating), 'Registered Nursing Staffing': parseFloat(v.rn_staffing_rating)}};
						}
						p.raw = parseFloat(v[filter]).toFixed(0);
					}
					return p;
				},
				function(p,v){
					if(firstFacilities.indexOf(v[index]) !== -1){
						p.total = 0;
						p.state = v[index];
					}
					return p;
				},
				function(){
					return{
						total: 0,
						other: '',
						marker: {},
						tooltip: [],
						raw: 0
					};
				}
			);
		}else{
			mainGroup = mainDimension.group().reduce(
				function(p,v){
					if(firstFacilities.indexOf(v.provider_number) !== -1){
						p.total = 1;
						p.provider_number = v.provider_number;
						p.tooltip = {name: v.facility_name, city: v.city, state: v.state, ratings: {'Health Inspection': v.health_inspection_rating, 'Quality Measures': v.qm_rating, 'Registered Nursing Staffing': v.rn_staffing_rating}};
					}
					return p;
				},
				function(p,v){
					if(firstFacilities.indexOf(v.provider_number) !== -1){
						p.total = 0;
						p.provider_number = v.provider_number;
					}
					return p;
				},
				function(){
					return{
						total: 0,
						provider_number: 0,
						marker: {},
						tooltip: []
					};
				}
			);
		}

		stackFacilities = flattenArray(stackFacilities);

		mainChart
			.dimension(mainDimension)
			.group(mainGroup, firstFacilities);
			for(var i = 0; i < stackFacilities.length; i++){
			    (function(j) {
			    	if(nearbyRange == 'federal' || nearbyRange == 'state'){
			    		var index = (nearbyRange == 'federal' ? 'state' : 'county');
				    	var group = mainDimension.group().reduce(
				         		function(p,v){
				         			if(v[index] == stackFacilities[j]){
				         				p.total = 1;
										p.other = v[index];
										if(nearbyRange == 'federal'){
											p.tooltip = {name: (states[v.state] == undefined ? thisFacilityData.facility_name : states[v.state]), ratings: {'Health Inspection': parseFloat(v.health_inspection_rating), 'Quality Measures': parseFloat(v.qm_rating), 'Registered Nursing Staffing': parseFloat(v.rn_staffing_rating)}};
										}else if(nearbyRange == 'state'){
											p.tooltip = {name: v.county, ratings: {'Health Inspection': parseFloat(v.health_inspection_rating), 'Quality Measures': parseFloat(v.qm_rating), 'Registered Nursing Staffing': parseFloat(v.rn_staffing_rating)}};
										}
										p.raw = parseFloat(v[filter]).toFixed(0);
				         			}
				         			return p;
				         		},
				         		function(p,v){
				         			if(v[index] == stackFacilities[j]){
				         				p.total = 0;
										p.state = v.steate;
				         			}
				         			return p;
				         		},
				         		function(){
				         			return{
				         				total: 0,
										other: '',
										marker: {},
										tooltip: [],
										raw: 0
				         			};
				         		}
				         );
			    	}else{
			    		var group = mainDimension.group().reduce(
				         		function(p,v){
				         			if(v.provider_number == stackFacilities[j]){
				         				p.total = 1;
										p.provider_number = v.provider_number;
										p.tooltip = {name: v.facility_name, city: v.city, state: v.state, ratings: {'Health Inspection': v.health_inspection_rating, 'Quality Measures': v.qm_rating, 'Registered Nursing Staffing': v.rn_staffing_rating}};
				         			}
				         			return p;
				         		},
				         		function(p,v){
				         			if(v.provider_number == stackFacilities[j]){
				         				p.total = 0;
										p.provider_number = v.provider_number;
				         			}
				         			return p;
				         		},
				         		function(){
				         			return{
				         				total: 0,
										provider_number: 0,
										marker: {},
										tooltip: [],
				         			};
				         		}
				         );
			    	}
			    	mainChart
			    	 	.stack(group, function(d){
			    	 		return d.value.total;
			    	 	}, stackFacilities[j]);
			    })(i);
			}

		mainValueAccessor = {
								valueAccessor: function(p){
									return p.value.total;
								}
							};

	}else{
		setMainDimension();
		if(mainGraphFilter == 'admissions'){
			paytypeFunction = function(PayArray){
				var sorted = Object.keys(PayArray).sort(function(a,b){return a - b});
				return PayArray[sorted[0]];
			}
			createMainFilterGroup(paytypeFunction);
		}else if(mainGraphFilter == 'census'){
			paytypeFunction = function(PayArray){
				var sorted = Object.keys(PayArray).sort(function(a,b){return a - b});
				return PayArray[sorted[0]];
			}
			createMainFilterGroup(paytypeFunction);
		}else{
			createMainFilterGroup();
		}
	}
}

function setMainDimensionTo(dateToUse, onlyMonth){
	onlyMonth = (onlyMonth != undefined ? onlyMonth : false);
	mainDimension = ndx.dimension(function(d){
		if(isWithinMonth && !onlyMonth){
			return d3.time.day(d[dateToUse]);
		}else{
			return d3.time.month(d[dateToUse]);
		}
	});
}
function setMainGroupPaytypeStackedWith(paytypeSort, customVariables, stackBy){
	customVariables = (customVariables != undefined ? customVariables : []);
	stackBy = (stackBy != undefined ? stackBy : 'count');
	var paytypes = getPaytypes();
	var firstType = paytypes[0];
	paytypes.splice(0,1);
	mainGroup = mainDimension.group().reduce(
		function(p,v){
			var name = {'name': v.name, 'id': v.id, paytype: paytypeSort(v.financial_change)};
			if(paytypeSort(v.financial_change) == firstType){
				p.count++;
				if(p.names['all'].indexOf(name) === -1){
					p.names['all'].push(name);
				}
				p.type = firstType;
       		 	customVariables.forEach(function(d){
					p[d.varName] = d.addition(p,v);
				});
			}
			return p;
		},
		function(p,v){
			var name = {'name': v.name, 'id': v.id, paytype: paytypeSort(v.financial_change)};
			if(paytypeSort(v.financial_change) == firstType){
				p.count--;
				var allNames = p.names['all'];
				for(var i = 0; i < allNames.length; i++){
					if(allNames[i].id == name.id){
						allNames.splice(i,1);
						i--;
					}
				}
				p.names['all'] = allNames;
				customVariables.forEach(function(d){
					p[d.varName] = d.subtraction(p,v);
				});
			}
			return p;
		},
		function(){
			var defaultVars = {
				count: 0,
				names: {'all': []},
				type: ''
			};
			customVariables.forEach(function(d){
				defaultVars[d.varName] = d.defaultState;
			});
			return defaultVars;
		}
	);
	mainChart
		.dimension(mainDimension)
		.group(mainGroup, firstType);
	for(var i = 0; i < paytypes.length; i++){
	    (function(j) {
	    	var group = mainDimension.group().reduce(
	         		function(p,v){
	         			var name = {'name': v.name, 'id': v.id, paytype: paytypeSort(v.financial_change)};
	         			if(paytypeSort(v.financial_change) == paytypes[j]){
	         				p.count++;
	         				if(p.names['all'].indexOf(name) === -1){
	         					p.names['all'].push(name);
	         				}
	         				p.type = paytypeSort(v.financial_change);
	         				customVariables.forEach(function(d){
									p[d.varName] = d.addition(p,v);
								});
	         			}
	         			return p;
	         		},
	         		function(p,v){
	         			var name = {'name': v.name, 'id': v.id, paytype: paytypeSort(v.financial_change)};
	         			if(paytypeSort(v.financial_change) == paytypes[j]){
	         				p.count--;
	         				var allNames = p.names['all'];
	         				for(var i = 0; i < allNames.length; i++){
	         					if(allNames[i].id == name.id){
	         						allNames.splice(i,1);
	         						i--;
	         					}
	         				}
	         				p.names['all'] = allNames;
	         				customVariables.forEach(function(d){
	         					p[d.varName] = d.subtraction(p,v);
	         				});
	         			}
	         			return p;
	         		},
	         		function(){
	         			var defaultVars = {
	         				count: 0,
	         				names: {'all': []},
	         				type: ''
	         			};
	         			customVariables.forEach(function(d){
	         				defaultVars[d.varName] = d.defaultState;
	         			});
	         			return defaultVars;
	         		}
	         	);
	        mainChart
	         	.stack(group, function(d){
	         		return d.value[stackBy];
	         	}, paytypes[j]);
	    })(i);
	}
	mainValueAccessor = {
							valueAccessor: function(p){
								return p.value[stackBy];
							}
						};
}

function setMainDimension(){
	var dateToUse;
	if(mainGraphFilter == 'discharges'){
		dateToUse = 'discharge_dt';
		mainDimension = ndx.dimension(function(d){
			return d.financial;
		});
		mainValueAccessor = {
								valueAccessor: function(p){
									return p.value.total;
								}
							};
	}else if(mainGraphFilter == 'admissions'){
		dateToUse = 'admit_dt';
		mainDimension = ndx.dimension(function(d){
			return d.financial;
		});
		mainValueAccessor = {
								valueAccessor: function(p){
									return p.value.total;
								}
							};
	}else if(mainGraphFilter == 'census'){
		mainDimension = ndx.dimension(function(d){
			if(isWithinMonth){
				var sorted = Object.keys(d.financial_change).sort(function(a,b){return a - b});
				return d.financial_change[sorted[0]];
			}else{
				return d3.time.month(d.admit_dt);
			}
		});
		mainValueAccessor = {
								valueAccessor: function(p){
									return p.value.adcAverage;
								}
							};
	}else if(mainGraphFilter == 'paytype'){
		mainDimension = ndx.dimension(function(d){
			var sorted = Object.keys(d.financial_change).sort(function(a,b){return a - b});
			return d.financial_change[sorted[0]];
		});
		mainValueAccessor = {
								valueAccessor: function(p){
									return p.value.total;
								}
							};
	}else if(mainGraphFilter == 'rawreadmission'){
		mainDimension = ndx.dimension(function(d){
			return d3.time.month(d.admit_dt);
		});
		mainValueAccessor = {
								valueAccessor: function(d){
									return d.value.readmitPercent * 100;
								}
							};
	}else if(mainGraphFilter == 'riskadjusted'){
		mainDimension = ndx.dimension(function(d){
			return d3.time.month(d.admit_dt);
		});
		mainValueAccessor = {
								valueAccessor: function(d){
									return d.value.riskAdjustPercent * 100;
								}
							};
	}else if(mainGraphFilter == 'lengthofstay' || mainGraphFilter == 'lengthofstaytotal'){
		mainDimension = ndx.dimension(function(d){
			if(isWithinTimeRange(d.admit_dt) && d.LOS != 'Unknown'){
				return d3.time.month(d.admit_dt);
			}
		});
		mainValueAccessor = {
								valueAccessor: function(d){
									return d.value.avgLOS;
								}
							};
	}else if(mainGraphFilter == 'physician'){
		mainDimension = ndx.dimension(function(d){
			return d.doctor;
		});
		mainValueAccessor = {
								valueAccessor: function(p){
									return p.value.total;
								}
							};
	}else if(mainGraphFilter == 'origin'){
		mainDimension = ndx.dimension(function(d){
			return d.origin;
		});
		mainValueAccessor = {
								valueAccessor: function(p){
									return p.value.total;
								}
							};
	}else if(mainGraphFilter == 'diagnosis'){
		mainDimension = ndx.dimension(function(d){
			return d.diagnosis;
		});
		mainValueAccessor = {
								valueAccessor: function(p){
									return p.value.count;
								}
							};
	}else if(mainGraphFilter == 'deficiencies'){
		mainDimension = deficienciesNDX.dimension(function(d){
			return d.letter;
		});
		mainValueAccessor = {
								valueAccessor: function(p){
									return p.value.count;
								}
							};
	}else if(mainGraphFilter == 'compare-star'){
		var filter = 'overall_rating';
		compareStarRatings.forEach(function(d){
		    if(d.selected){
		        filter = d.key;
		    }
		});
		var compareStarDimenision = compareNDX.dimension(function(d){
		    return d[filter];
		});
		mainValueAccessor = {
								valueAccessor: function(p){
									return p.value.count;
								}
							};
	}else{
		mainDimension = ndx.dimension(function(d){
			if(isWithinMonth){
				return d3.time.day(d['admit_dt']);
			}else{
				return d3.time.month(d['admit_dt']);
			}
		});
	}
}


function createMainFilterGroup(financialFunction){
	paytypeFunction = function(PayArray){
		try{
			var sorted = Object.keys(PayArray).sort(function(a,b){return b - a});
			return PayArray[sorted[0]];
		}catch(err){}
	}
	if(financialFunction != undefined) paytypeFunction = financialFunction;
	mainGroup = mainDimension.group().reduce(
		function (p,v){
			var name = {'name': v.name, 'id': v.id, 'paytype': paytypeFunction(v.financial_change), 'origin': v.origin};
			if(mainGraphFilter == 'discharges'){
				if(v.discharge_dt != 'In-house'){
					if(v.readmit > 0){
						p.readmit += parseInt(v.readmit);
						if(p.names[1].indexOf(name) === -1){
							p.names[1].push(name);
						}
					}else{
						p.val++;
						if(p.names[0].indexOf(name) === -1){
							p.names[0].push(name);
						}
					}
				}
			}
			p.total++;
			++p.count;
        	if(p.names['all'].indexOf(name) === -1){
        		p.names['all'].push(name);
        		p.readmits += (v.readmit == 1 ? 1 : 0);
            }
            p.readmitPercent = p.count ? p.readmits/p.count : 0;
            p.riskAdjustPercent = p.count ? riskAdjustedRate((p.readmits/p.count), 0.195, 0.185) : 0;
            if(v.LOS != 'Unknown'){
	            p.los += v.LOS;
            	p.avgLOS = p.count ? (p.los / p.count) : 0
        	}
            p.adc = p.count;
            if(mainGraphFilter == 'census'){
            	var monthYear = new Date(v.admit_dt);
				p.adcAverage = p.count / daysInMonth((monthYear.getMonth() + 1), monthYear.getFullYear());
            }
            p.origin = v.origin;
            if(mainGraphFilter == 'deficiencies'){
            	var tooltip = {tag: v.tag, indicator: v.indicator_name};
            	p.tooltip.push(tooltip);
            	p.indicator = v.indicator_name;
     			p.td_uid = v.td_uid;
            	p.names['all'] = [];
				v.samples.forEach(function(sample, i){
					if(typeof sample == 'string' || sample instanceof String){
						var name = {'name':sample, 'id':0, 'paytype':0, 'origin':0, 'answer': p.type};
					}else{ //its a resident that we matched
						var name = {'name': sample.name, 'id': sample.id, 'paytype': sample.financial, 'origin': sample.origin, 'answer': p.type};
					}
					if(v.no.indexOf((i + 1).toString()) !== -1){
						p.answers[(i + 1)] = 2;
					}else if(v.yes.indexOf((i + 1).toString()) !== -1){
						p.answers[(i + 1)] = 1;
					}
					if(p.names['all'].indexOf(name) === -1){
	        			p.names['all'].push(name);
	            	}
				});
            	p.ftag = v.deptartment_abbreviation+'-'+v.ind_dep_count;
            	p.regulation = v.regulation;
            	if(!(v.department in p.category)){
            		p.category[v.department] = [];
            	}
            	p.category[v.department].push(v.td_uid);
            	p.month = v.month;
            	p.year = v.year;
            }else if(mainGraphFilter == 'compare-star'){
            	if(nearbyRange != 'federal'){
            		p.tooltip.push({name: v.facility_name, city: v.city, state: v.state, ratings: {'Health Inspection': v.health_inspection_rating, 'Quality Measures': v.qm_rating, 'Registered Nursing Staffing': v.rn_staffing_rating}});
            	}else{
            		p.tooltip.push({name: (states[v.state] == undefined ? toTitleCase(thisFacilityData.facility_name) : states[v.state]), city: v.city, state: v.state, ratings: {'Health Inspection': v.health_inspection_rating, 'Quality Measures': v.qm_rating, 'Registered Nursing Staffing': v.rn_staffing_rating}});
            	}
            }
			return p;
		},
		function (p,v){
			var name = {'name': v.name, 'id': v.id, 'paytype': paytypeFunction(v.financial_change), 'origin': v.origin};
			if(mainGraphFilter == 'discharges'){
				if(v.readmit > 0){
					p.readmit -= parseInt(v.readmit);
					if(p.names[1].indexOf(name) > -1){
						p.names[1].splice(p.names[1].indexOf(name), 1);
					}
				}else{
					p.val--;
					if(p.names[0].indexOf(name) > -1){
						p.names[0].splice(p.names[0].indexOf(name), 1);
					}
				}
			}
			p.total--;
			--p.count;
            p.readmits -= (v.readmit == 1 ? 1 : 0);
            p.readmitPercent = p.count ? p.readmits/p.count : 0;
            p.riskAdjustPercent = p.count ? riskAdjustedRate((p.readmits/p.count), 0.195, 0.185) : 0;
            if(v.LOS != 'Unknown'){
            	p.los -= v.LOS;
            	if(!isWithinMonth){
            		p.avgLOS = p.count ? (p.los / p.count) : 0
            	}else{
            		p.avgLOS = v.LOS;
            	}
            }
            var allNames = p.names['all'];
            for(var i = 0; i < allNames.length; i++){
            	if(allNames[i].name == name.name){
            		allNames.splice(i,1);
            		i--;
            	}
            }
            p.names['all'] = allNames;
            p.adc = p.count;
            if(mainGraphFilter == 'census'){
            	var monthYear = new Date(v.admit_dt);
            	p.adcAverage = p.count / daysInMonth((monthYear.getMonth() + 1), monthYear.getFullYear());
            }
            var allTooltip = p.tooltip;
            if(mainGraphFilter == 'deficiencies'){
	            for(var i = 0; i < allTooltip.length; i++){
	            	if(allTooltip[i].name == name.name){
	            		allTooltip.splice(i,1);
	            		i--;
	            	}
	            }
	            p.tooltip = allTooltip;
        	}
        	p.td_uid = v.td_uid;
			return p;
		},
		function(){
			var defaults = {
				readmit: 0,
				val: 0,
				names: {0: [], 1: [], 'all': []},
				regularDischarge: 0,
				inhouse: 0,
				total: 0,
				count: 0,
                readmits: 0,
                readmitPercent: 0,
                riskAdjustPercent: 0,
                los: 0,
                avgLOS: 0,
                adc: 0,
                adcAverage: 0,
                origin: '',
                tooltip: [],
				answers: {},
				indicator: '',
				td_uid: 0,
				ftag: '',
				regulation: '',
				category: {},
				month: 0,
				year: '',
				marker: {},
				indicatorsLength: 0,
				provider_number: 0,
			}
			return defaults;
		}
	);
}



function setMainGraphAsDateRange(){
	var from = $('#from').datepicker('getDate');
	from.setDate(from.getDate()-1)
	var to = $('#to').datepicker('getDate');
	mainChart
		.x(d3.time.scale().domain([from, $('#to').datepicker('getDate')]))
		.round(d3.time.days.round)
	    .xUnits(d3.time.days);

	if(!isWithinMonth){
		var from = $('#from').datepicker('getDate');
		var to = $('#to').datepicker('getDate');
		var hasResults = true;
		var monthsBetween = monthDiff(from, to);

		mainChart
			.elasticX(true)
			.xAxisPadding((hasResults ? ((monthsBetween * 2)+2) : 1))
		    .round(d3.time.month.round)
		    .xUnits(function(){
		    	return monthsBetween * 2;
		    });

		mainChart.xAxis().ticks(monthsBetween);

		mainChart.xAxis().tickFormat(d3.time.format('%B'));
		if(mainGraphFilter == 'rawreadmission' || mainGraphFilter == 'riskadjusted' || mainGraphFilter == 'census'){
			mainChart.yAxis().tickFormat(function(v) {return v + "%";});
		}

		from.setDate(from.getDate()+1)
		if(from.getMonth() == to.getMonth()){
			mainChart
				.centerBar(true)
				.xUnits(function(){
					return 2;
				});
			 mainChart.xAxis().ticks(d3.time.months);
		}
		
	}else{
		mainChart.xAxis().ticks(d3.time.days);
		mainChart.xAxis().tickFormat(d3.time.format('%d'));
		if(mainGraphFilter == 'census'){
			mainChart.yAxis().tickFormat(function(v) {return v + "%";});
		}
	}
}
$(document).on('click', '.mainFilter', function(event){
	event.preventDefault();
	var previousMainGraphFilter = mainGraphFilter;
	$(this).closest('.filter').siblings('.filter').children('.filter-chart').css({'background': 'none', 'border-color': '#fff'});
	$('.d3-tip').css({ opacity: 0, 'pointer-events': 'none', 'display': 'none' });
	if($(this).hasClass('noclick') || $(this).hasClass('neverClick') || (isTour && tourStep != 13 && tourStep != 15 && tourStep != 25 && tourStep != 9 && tourStep != 1) && (isTour && $(this).data('ignoreDemo') == undefined && !$(this).data('ignoreDemo'))){
		return;
	}
	var subfilters = $(this).siblings('.sub-filters');
	if(mainGraphFilter == $(this).attr('data-filter')){
		return false;
	}
	if($(this).data('demo') != undefined && $(this).data('demo') == true){
		graphType = 'Bar';
		$('#graphTypes .selected').removeClass('selected');
		$('#graphTypes li').eq(0).addClass('selected');
	}
	$(subfilters).find('.selected').removeClass('selected');
	customFilterValues.readmissions.selected = false;
	var that = $(this);
	$('#printFilters input').attr('checked', false);
	$('.hasGraph li').removeClass('active');
	$('.hasGraph li[data-print-filter="' + $(this).data('print-filter') + '"]').addClass('active');
	$('#printFilters input[name="' + $(this).data('print-filter') + '"]').attr('checked', true);
	$('#main-chart #animate').css('display', 'block');
	if(mainGraphFilter == 'compare-star' && nearbyRange == 'federal'){
		nearbyRange = 'county';
		distanceRatings[1]['selected'] = true;
		getCompareData(true, function(){setCorrectGraphInformation();});
	}
	$('#main-chart #animate').animate({
		opacity: 1
	}, 300, function(){
		$('.filters .filter .mainFilter').siblings('.filter-chart').css({'background': 'none', 'border-color': '#fff'});
		$('.filters .filter .mainFilter').css({'background': '#e5b143', 'color': '#000'});
		$('.filter.active').removeClass('active');
		$(that).closest('.filter').addClass('active');
		if(mainGraphFilter == ''){
			$('.filters').removeClass('select').prepend('<h1>Filters</h1>');
			$('#percents').css('display', 'block');
		}
		mainGraphFilter = $(that).data('filter');
		$('#mainFilterText').text($(that).data('title'));
		if((mainGraphFilter == 'rawreadmission' || mainGraphFilter == 'riskadjusted' || mainGraphFilter == 'lengthofstay' || mainGraphFilter == 'surveys' || mainGraphFilter == 'qis') && isWithinMonth){
			var from = $('#from').datepicker('getDate');
			from.setMonth(from.getMonth() - 1);
			$('#from').datepicker('setDate', from);
			$('.d3-tip').css({ opacity: 0, 'pointer-events': 'none', 'display': 'none' });
			if(mainGraphFilter == 'lengthofstay'){
				getGraphData();
			}else{
				generateGraphs(true);
			}
		}else{
			$('.d3-tip').css({ opacity: 0, 'pointer-events': 'none', 'display': 'none' });
			if(previousMainGraphFilter == 'census') getGraphData();
			else generateGraphs(true);
		}
	});
});
if(!checkifMobile()){
	$('.menu-wrap').hover(
		function(){
			if(isTour){
				return;
			}
			if(!$(this).parent().hasClass('active') && !$(this).find('.mainFilter').hasClass('noclick')){
				$(this).siblings('.filter-chart').css({'background': '#fefbe2', 'border-color': '#fefbe2'});
			}
		},
		function(){
			if(isTour){
				return;
			}
			if(!$(this).parent().hasClass('active') && !$(this).find('.mainFilter').hasClass('noclick')){
				$(this).siblings('.filter-chart').css({'background': 'none', 'border-color': '#fff'});
			}
		}
	);
}

$(document).on('click', '.sub-filters > li', function(e){
	if(checkifMobile()){
		if($(this).hasClass('selected') && ($(this).data('hasSelected') == undefined || $(this).data('hasSelected') == false)){
			$(this).removeClass('selected');
			$(this).find('ul.inner-sub-filter').hide();
		}else{
			$(this).parent().find('li > .inner-sub-filter').each(function(index, value){
				if($(this).find('.selected').length == 0){
					$(this).closest('li').removeClass('selected').data('hasSelected', false);
				}
			});
			$(this).addClass('selected');
			$(this).find('ul.inner-sub-filter').show();
		}
	}
});
$(document).on('click', '.sub-filter', function(e){
	e.preventDefault();
	var parentFilter = $(this).closest('.filter');
	if($(this).hasClass('disabled') || (parentFilter.hasClass('showfilters') && !parentFilter.hasClass('demo-open'))){
		return false;
	}
	if(isTour && parentFilter.hasClass('showfilters') && parentFilter.hasClass('demo-open')){
		$.powerTour('end');
		parentFilter.data('continueTour', true);
	}else if(isTour){
		parentFilter.data('continueTour', false);
	}
	if(removedResidents.length != 0){
		removeResidentRefresh = true;
	}
	var chartToFilter = $(this).attr('data-chart-filter');
	var filter = $(this).attr('data-trigger-filter');
	if(!parentFilter.hasClass('active')){
		parentFilter.find('.mainFilter').click();
		subfilterClicked[chartToFilter] = {filter: filter, chart: chartToFilter, more: false};
		if(chartToFilter == 'diagnosisChart' && filter != 'more'){
			subfilterClicked[chartToFilter].more = true;
			subfilterClicked[chartToFilter].used = false;
		}
		return;
	}
	if($(this).attr('data-custom-filter') == 'single'){
		var handler = $(this).data('do-function');
		if(handler != undefined){
			handler(filter);
		}
		return;
	}
	var backwards = (customFilterValues[chartToFilter] != undefined ? customFilterValues[chartToFilter].backwards : false);
	if($(this).hasClass('selected') && !$(this).hasClass('no-inner-sub') && !backwards){
		$(this).removeClass('selected');
		if($(this).closest('.inner-sub-filter').find('.selected').length == 0){
			$(this).closest('.inner-sub-filter').find('.selected').data('hasSelected', false);
		}else{
			$(this).closest('.inner-sub-filter').find('.selected').data('hasSelected', true);
		}
		if(chartToFilter == 'diagnosisChart' && filter == 'more'){
			$(this).unbind('mouseenter mouseleave');
			$('.more[data-more="diagnosis"]').click();
		}else if(chartToFilter == 'ftagChart' && filter == 'more'){
			$(this).unbind('mouseenter mouseleave');
			$('.more[data-more="ftags"]').click();
		}else if(chartToFilter == 'regulationChart' && filter == 'more'){
			$(this).unbind('mouseenter mouseleave');
			$('.more[data-more="regulations"][data-chart="regulationChart"]').click();
		}else if(chartToFilter == 'regulationSurveyChart' && filter == 'more'){
			$(this).unbind('mouseenter mouseleave');
			$('.more[data-more="regulations"][data-chart="regulationSurveyChart"]').click();
		}else if(chartToFilter == 'regulationQISChart' && filter == 'more'){
			$(this).unbind('mouseenter mouseleave');
			$('.more[data-more="regulations"][data-chart="regulationQISChart"]').click();
		}else if(chartToFilter == 'ftagSurveyChart' && filter == 'more'){
			$(this).unbind('mouseenter mouseleave');
			$('.more[data-more="ftags"][data-chart="ftagSurveyChart"]').click();
		}else if(chartToFilter == 'ftagQISChart' && filter == 'more'){
			$(this).unbind('mouseenter mouseleave');
			$('.more[data-more="ftags"][data-chart="ftagQISChart"]').click();
		}else{
			if($(this).data('custom-filter') == true){
				var filterValues = customFilterValues[chartToFilter].filters;
				for(var i = 0; i < filterValues.length; i++){
					if(filterValues[i].key == filter){
						filterValues[i].filterFunction(false);
					}
				}
			}else if(chartToFilter in window){
				chartToFilter = window[chartToFilter];
				chartToFilter.filter(filter);
				dc.redrawAll();
			}
		}
	}else if(!backwards && !$(this).hasClass('no-inner-sub')){
		if(chartToFilter == 'diagnosisChart' && filter == 'more'){
			$(this).unbind('mouseenter mouseleave');
			$('.more[data-more="diagnosis"]').click();
		}else if(chartToFilter == 'regulationChart' && filter == 'more'){
			$(this).unbind('mouseenter mouseleave');
			$('.more[data-more="regulations"][data-chart="regulationChart"]').click();
		}else if(chartToFilter == 'regulationSurveyChart' && filter == 'more'){
			$(this).unbind('mouseenter mouseleave');
			$('.more[data-more="regulations"][data-chart="regulationSurveyChart"]').click();
		}else if(chartToFilter == 'regulationQISChart' && filter == 'more'){
			$(this).unbind('mouseenter mouseleave');
			$('.more[data-more="regulations"][data-chart="regulationQISChart"]').click();
		}else if(chartToFilter == 'ftagSurveyChart' && filter == 'more'){
			$(this).unbind('mouseenter mouseleave');
			$('.more[data-more="ftags"][data-chart="ftagSurveyChart"]').click();
		}else if(chartToFilter == 'ftagQISChart' && filter == 'more'){
			$(this).unbind('mouseenter mouseleave');
			$('.more[data-more="ftags"][data-chart="ftagQISChart"]').click();
		}else{
			$(this).addClass('selected').closest('.inner-sub-filter').parent().addClass('selected').data('hasSelected', true);
			if($(this).data('custom-filter') == true){
				if($(this).closest('.inner-sub-filter').find('.selected').length > 0){
					$(this).closest('.inner-sub-filter').find('.selected').not(this).removeClass('selected');
					resetMainGraph(false);
				}
				var filterValues = customFilterValues[chartToFilter].filters;
				for(var i = 0; i < filterValues.length; i++){
					if(filterValues[i].key == filter){
						filterValues[i].filterFunction(true);
					}
				}
			}else if(chartToFilter in window){
				chartToFilter = window[chartToFilter];
				chartToFilter.filter(filter);
				dc.redrawAll();
			}
		}
	}else if($(this).hasClass('selected') && !$(this).hasClass('no-inner-sub') && backwards){
		$(this).removeClass('selected');
		var filterValues = customFilterValues[chartToFilter].filters;
		if($(this).closest('.inner-sub-filter').find('.selected').length == 0){
			for(var i = 0; i < filterValues.length; i++){
				filterValues[i].selected = true;
			}
			filterValues[0].filterFunction(false);
		}else{
			for(var i = 0; i < filterValues.length; i++){
				if(filterValues[i].key == filter){
					filterValues[i].filterFunction(true);
				}
			}
		}
	}else if(!$(this).hasClass('selected') && !$(this).hasClass('no-inner-sub') && backwards){
		$(this).addClass('selected');
		var filterValues = customFilterValues[chartToFilter].filters;
		for(var i = 0; i < filterValues.length; i++){
			if(filterValues[i].key == filter){
				filterValues[i].filterFunction(false);
			}
		}
	}else if($(this).hasClass('no-inner-sub') && !$(this).hasClass('selected')){
		$(this).addClass('selected');
		var options = $(this).data('no-sub');
		options.filter(true);
	}else if($(this).hasClass('no-inner-sub') && $(this).hasClass('selected')){
		$(this).removeClass('selected');
		var options = $(this).data('no-sub');
		options.filter(false);
	}
	return false;
});